module.exports = require("babel-runtime/helpers/createClass");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/createClass"
// module id = 35
// module chunks = 0